import { EvmAddressSummaryInfo, EvmDeployContractInfo, EvmDeployContractListInfo } from '~/api/repository'
import { ListBaseModel } from '~/types/model/base.model'
import { DATE_FORMATS, secondsToDate } from '~/utils/dateFormat'
import { setComma } from '~/utils/numberFormat'

/** @description
 * 테이블의 from, to 등의 주소 정보에 사용되는 모델
 */
export class AddressSummaryModel {
  private _address: string
  private _addressType: EvmAddressSummaryInfo.ADT
  private _name?: string
  private _symbol?: string

  constructor (data: EvmAddressSummaryInfo) {
    this._address = data.ADDR
    this._addressType = data.ADT
    this._name = data.NN
    this._symbol = data.SB
  }

  get address () {
    return this._address
  }

  get addressType () {
    return this._addressType
  }

  get name () {
    return this._name
  }

  get symbol () {
    return this._symbol
  }
}

export class DeployedContractModel {
  private _address: string
  private _contractName: string
  private _compiler: string
  private _compilerVersion: string
  private _balance: string
  private _transactionCount: string
  private _deployedDate: number

  constructor (data: EvmDeployContractInfo) {
    this._address = data.ADDR
    this._contractName = data.CNM
    this._compiler = data.CMP
    this._compilerVersion = data.CMPVER
    this._balance = data.BL
    this._transactionCount = data.TRXCNT
    this._deployedDate = data.DPLUT
  }

  get address (): string {
    return this._address
  }

  get contractName (): string {
    return this._contractName
  }

  get compiler (): string {
    return this._compiler
  }

  get compilerVersion (): string {
    return this._compilerVersion
  }

  get balance (): string {
    return setComma(this._balance)
  }

  get transactionCount (): string {
    return setComma(this._transactionCount)
  }

  get deployedDate (): string {
    return secondsToDate(this._deployedDate, DATE_FORMATS.dateWithTime)
  }
}

export class DeployedContractListModel extends ListBaseModel {
  private _contractList: Array<EvmDeployContractInfo>

  constructor (data: EvmDeployContractListInfo) {
    super(data.TCNT, data.VCNT)
    this._contractList = data.CALIST
  }

  get contractList (): Array<DeployedContractModel> {
    return this._contractList.map(contract => new DeployedContractModel(contract))
  }
}